import api from '@/api'
import Multiselect from 'vue-multiselect'
import { mapGetters } from 'vuex'
import chatbox from './livechat-chatbox'
import LivechatChattool from './livechat-chattool'
import users from './LivechatUsers/LivechatUsersSocket.vue'

import LivechatPagelist from './livechat-pagelist'
import LivechatSearch from './LivechatSearch'
import LivechatSearchBox from './LivechatSearchBox'
import LivechatTab from './LivechatTab'

import LivechatSocialChannelMixin from './LivechatSocialChannelMixin'

export default {
  mixins: [LivechatSocialChannelMixin],
  props: {
    isMobile: { default: false }
  },
  components: {
    chatbox: chatbox,
    users: users,
    Multiselect,
    LivechatChattool,
    LivechatPagelist,
    LivechatSearch,
    LivechatSearchBox,
    LivechatTab
  },
  data() {
    return {
      app: '',
      timer: '',
      type: 'bot',
      allrentcustomer: [],
      allrentsupplier: [],
      usersearching: false,
      toolListHeight: 0,
      showSearch: false,
      openStartDate: false,
      openStartTime: false,
      openEndDate: false,
      openEndTime: false,
      input: {
        uuAreaName: '',
        search: '',
        uu_register_status: '',
        lastconversationfromdate: null,
        lastconversationtodate: null,
        lastconversationfromtime: null,
        lastconversationtotime: null,
        lastconversationfrom: null,
        lastconversationto: null,
        phoneno: null,
        uu_name: null,
        keyword: '',
        tags: [],
        status: null,
        app: '',
        session: '',
        assignadminname: ''
      },
      loading: false,
      selectedUser2: null
    }
  },
  async created() {
    var vm = this

    if (vm.$store.state.livechat.filter.search) {
      vm.$store.state.livechat.filter.search = ''
    }

    if (vm.$route.query.inbox) {
      vm.$store.commit('SET_LIVECHAT_TYPE', vm.$route.query.inbox == 'bot' ? 'bot' : 'admin')
    }

    if (vm.$route.query.platform_type) {
      vm.$store.commit(
        'SET_LIVECHAT_PLATFORM_TYPE',
        vm.$route.query.platform_type == 'page' ? 'page' : 'inbox'
      )
    }

    if (vm.$route.query.pageid) {
      vm.$store.state.livechat.pageid = vm.$route.query.pageid
      // vm.$store.state.selectedBot.pageid = vm.$route.query.pageid
    }

    if (vm.$route.query.userid) {
      var userid = vm.$route.query.userid

      if (userid) {
        const user_response = await vm.getUsersdata(userid)
        if (user_response) {
          vm.selectedUser = {
            app: user_response.app,
            first_name: user_response.first_name,
            last_name: user_response.last_name,
            lastreply_time: null,
            profile_pic: user_response.profile_pic,
            session: '',
            sessionvalue: user_response.sessionvalue,
            userid: user_response.id,
            uu_areaname: null,
            type: user_response.context == 'contactadmin' ? 'admin' : '',
            platform_thread_id: vm.$route.query.platform_thread_id,
            platform_post_id: vm.$route.query.platform_post_id,
            platform_type: vm.$route.query.platform_type,
            user_id: user_response.id,
            page_id: user_response.pageid
          }

          vm.$store.commit('SET_LIVECHAT_USER', vm.selectedUser)
          if (vm.isMobile) {
            await vm.$nextTick()
            vm.view = 'chatbox'
          }
        } else {
          vm.$swal({
            type: 'info',
            title: 'Not found this user'
          })
        }
      }
    }

    if (
      vm.selectedBot.theme == 'ticket' ||
      vm.$store.state.ticketPageid.includes(vm.selectedBot.pageid)
    ) {
      vm.$store.dispatch('loadAgents')
      vm.$store.dispatch('loadAgentGroups')
      vm.$store.dispatch('loadAgentSubGroups')
    }
    vm.handleFetchLivechatNotiUnread().then((val) => {
      if (val && document.getElementById('noti_sound')) document.getElementById('noti_sound').play()
    })

    let refreshNotiunread = 5000 // 5 sec
    vm.timer = setInterval(() => {
      vm.handleFetchLivechatNotiUnread().then((val) => {
        if (val && document.getElementById('noti_sound'))
          document.getElementById('noti_sound').play()
      })
    }, refreshNotiunread)
  },
  beforeDestroy: function () {
    clearInterval(this.timer)
  },
  mounted: function () {
    this.$store.commit(
      'SET_LIVECHAT_TYPE',
      this.$route.query.inbox && ['bot', 'admin'].includes(this.$route.query.inbox)
        ? this.$route.query.inbox
        : 'admin'
    )
    this.$store.commit(
      'SET_LIVECHAT_PLATFORM_TYPE',
      this.$route.query.platform_type && ['inbox', 'page'].includes(this.$route.query.platform_type)
        ? this.$route.query.platform_type
        : 'inbox'
    )
  },
  computed: {
    newchatnotify() {
      return this.$store.state.newchatnotify
    },
    isUnlock() {
      var bot = this.botlist.find((el) => {
        return el.pageid == this.$store.state.livechat.pageid
      })
      if (!bot) return false
      return (
        (bot.pagetype == 'enterprise' && this.$store.state.livechatPageList.includes(bot.theme)) ||
        this.$store.state.livechatPageIdList.includes(bot.pageid) ||
        (bot.theme == 'ecommercebasic' && bot.pageid == '270028443161479') ||
        bot.isUnlockLivechat
      )
    },

    ...mapGetters({
      selectedBot: 'selectedBot',
      botlist: 'botlist',
      searchlist: 'getLivechatSearching',
      astonAdmins: 'getAstonAdmins',
      loadingAstonAdmin: 'getLoadingAstonAdmins',
      livechat: 'livechat'
    }),
    computedAstonAdmins() {
      if (this.$aston.astonpages.includes(this.$store.state.livechat.pageid)) {
        if (this.astonAdmins) {
          var admins = this.astonAdmins.map((el) => {
            return {
              text: el.name,
              value: el.name
            }
          })
          admins.unshift({ text: 'ยังไม่ได้ Assign', value: '' })
          return admins
        } else {
          return []
        }
      } else {
        return []
      }
    },

    selectedUser: {
      get() {
        return this.$store.state.livechat.currentUser
      },
      set(newVal) {
        this.$store.state.livechat.currentUser = newVal
      }
    },
    filter: {
      get() {
        return this.$store.state.filter
      },
      set(val) {
        this.$store.state.filter = val
      }
    },
    areaname: function () {
      var area = this.$store.state.uuAreaName
      area.unshift('')
      return area
    },
    isQuickFilter() {
      return this.$store.state.livechat.filter && this.$store.state.livechat.filter.is_quick_filter
    }
  },
  methods: {
    async handleFetchLivechatNotiUnread() {
      let found = false
      for (let index = 0; index < this.botlist.length; index++) {
        const bot = this.botlist[index]

        const result = await this.$store.dispatch('livechatnotiunread', { pageid: bot.pageid })
        if (this.$store.state.livechat.pageid == bot.pageid) {
          found = result.found
        }
        this.$store.dispatch('calculateTotalLivechatNotiUnread', {
          data: result.data || {},
          livechatChannelOptions: this.livechatChannelOptions,
          bot
        })
      }
      return found
    },
    handleChangeFilter(filter) {
      this.filter = filter
    },
    changePage() {
      console.log('changePage')
      // this.newchatnotify = {}
      this.selectedUser = null
    },
    deleteTag(index) {
      this.$store.state.livechat.filter.tags.splice(index, 1)
    },
    clearSearch() {},
    getUsersdata: function (userid) {
      var vm = this
      return new Promise((resolve, reject) => {
        var data = {
          userid: userid,
          pageid: vm.$store.state.livechat.pageid
        }

        api.getUsersdata(data, function (error, response) {
          if (error) {
            reject(error)
          }

          if (response.data) {
            resolve(response.data[0])
          } else {
            resolve(undefined)
          }
        })
      })
    },
    onEndSession: async function () {
      await this.endSession()
      this.$set(this.$store.state.livechat, 'currentUser', null)
      this.$store.dispatch('updateLivechatUser', null)
      this.$store.dispatch('forceLoadLastestUsers')
    },
    endSession: function () {
      let vm = this
      if (vm.selectedUser == null || vm.selectedBot == null) {
        return false
      }
      let data = {
        pageid: vm.selectedUser.page_id,
        userid: vm.selectedUser.user_id
      }
      return new Promise((resolve, reject) => {
        vm.$store.dispatch('loading')
        api.endSessionChat(data, function (error) {
          if (error) {
            vm.$store.dispatch('loading')
            reject(error)
          }

          console.log('endSession')
          vm.selectedUser = null

          vm.$store.dispatch('loading')
          resolve()
        })
      })
    },
    onOpenSession: async function () {
      await this.openSession()
      this.$store.commit('SET_LIVECHAT_TYPE', 'admin')
      var user = this.$store.state.livechat.currentUser
      user.type = this.type
      this.$store.dispatch('updateLivechatUser', user)
      this.$store.dispatch('forceLoadLastestUsers')
      this.updateRoute()
    },
    openSession: function () {
      let vm = this

      if (vm.selectedUser == null || vm.selectedBot == null) {
        return false
      }
      let data = {
        pageid: vm.$store.state.livechat.pageid,
        userid: vm.selectedUser.userid
      }
      return new Promise((resolve, reject) => {
        vm.$store.dispatch('loading')
        api.openSessionChat(data, function (error) {
          if (error) {
            vm.$store.dispatch('loading')

            reject(error)
          }

          vm.$set(vm.selectedUser, 'type', 'admin')
          vm.$set(vm.selectedUser, 'context', 'contactadmin')
          vm.$store.commit('SET_LIVECHAT_USER', vm.selectedUser)

          vm.$store.dispatch('loading')
          resolve()
        })
      })
    },
    updateRoute: function () {
      var query = { ...this.$route.query }

      this.$router.push({
        name: 'allinonechat',
        path: '/allinonechat',
        query: query
      })
      this.routeValue = JSON.stringify(this.$route.query)
    }
  },
  watch: {
    selectedBot: function (newVal, oldVal) {
      if (newVal != oldVal) {
        var isCurrentUser = this.$store.state.livechat.currentUser

        if (isCurrentUser !== null && newVal.pageid !== this.$store.state.livechat.pageid) {
          this.$set(this.$store.state.livechat, 'currentUser', null)
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/view/livechat/Livechat.js